<template>
    <div class="assessment-item-tabs">
        <v-tabs
            v-model="currentTab"
            align-with-title
        >
            <v-tab
                v-for="tab in tabs"
                :key="tab"
            >
                {{ tab }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentTab">
            <v-tab-item
                v-for="( tab, index ) in tabs"
                :key="index"
                ref="tabs"
                eager
            >
                <StudentsRating :full="false" :loading="loading" />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StudentsRating from '../../../Shared/Grade/StudentsRating/index.vue';

export default {
    name: 'RatingTabs',
    components: {
        StudentsRating
    },
    props: {
        loading: Boolean
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo'
        })
    },
    data() {
        return {
            tabs: [ 'Группа' ],
            currentTab: null
        }
    },
    methods: {
        update(rating) {
            let byGroup = this.$parent.getRatingByGroup(rating);
            this.$refs.tabs[0].$children[0].update(byGroup);
            
            // this.$refs.tabs[1].$children[0].update(rating);
        }
    }
}
</script>

<style scoped>
.assessment-item-tabs >>> .v-tabs .v-tab {
    color: #4854FE;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: normal;
    text-transform: none;
}

.assessment-item-tabs >>> .v-tabs .v-slide-group__wrapper .v-slide-group__content {
    left: -42px;
    color: #e2e5ec;
}

.assessment-item-tabs >>> .v-tabs-items {
    min-height: 343px;
}
</style>
